'use client';

import { token } from '@terra/ui-styled-system';
import { Alert01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { Alert } from '../../components/alert';
import { Button } from '../../components/button';
import { BodyDefault } from '../../components/typography';

export type ApiDocumentationMissingAlertProps = {
  isBackendOnly: boolean;
  hasApiDocumentation: boolean;
  onOpenBusinessContext: () => void;
};

export function ApiDocumentationMissingAlert({
  isBackendOnly,
  hasApiDocumentation,
  onOpenBusinessContext,
}: ApiDocumentationMissingAlertProps) {
  const t = useTranslations(
    'designSystem.applicationGeneral.apiDocumentationMissing',
  );
  const showAlert = isBackendOnly && !hasApiDocumentation;

  if (!showAlert) {
    return null;
  }

  return (
    <Alert.Root
      px="4"
      py="2"
      borderColor="border.neutral.error"
      backgroundColor="bg.neutral.error"
      gap={2.5}
    >
      <Alert.Icon asChild>
        <Alert01Icon size={20} color={token('colors.fg.neutral.error')} />
      </Alert.Icon>
      <Alert.Content>
        <Alert.Title>{t('title')}</Alert.Title>
        <Alert.Description>
          <BodyDefault color="fg.neutral.default" whiteSpace="pre-line">
            {t.rich('description', {
              link: (chunks) => (
                <Button
                  variant="link"
                  size="sm"
                  onClick={onOpenBusinessContext}
                  p={0}
                  h="auto"
                  minH={0}
                  fontWeight="medium"
                  color="fg.neutral.default"
                  textDecoration="underline"
                >
                  {chunks}
                </Button>
              ),
            })}
          </BodyDefault>
        </Alert.Description>
      </Alert.Content>
    </Alert.Root>
  );
}
